import { OPERATION_TYPE } from "../../../util/varibles/constants";
import { MENU_CALENDAR, MENU_OP } from "../../PlanOperationPage/_components/Menu/options";

export const menuOptions: Partial<Record<OPERATION_TYPE, (MENU_OP | MENU_CALENDAR)[]>> = {
    [OPERATION_TYPE.HARVEST]: [
        MENU_OP.DETAIL,
        MENU_OP.START,
        MENU_OP.VESSEL_APPROVE,
        MENU_OP.DECLINE,
        MENU_OP.VESSEL_CANCEL,
    ],
    [OPERATION_TYPE.TREATMENT]: [
        MENU_OP.DETAIL,
        MENU_OP.START,
        MENU_OP.VESSEL_APPROVE,
        MENU_OP.DECLINE,
        MENU_OP.VESSEL_CANCEL,
    ],
    [OPERATION_TYPE.TRANSPORT]: [
        MENU_OP.DETAIL,
        MENU_OP.START,
        MENU_OP.VESSEL_APPROVE,
        MENU_OP.DECLINE,
        MENU_OP.VESSEL_CANCEL,
    ],
    [OPERATION_TYPE.EVENT]: [
        MENU_OP.DETAIL,
        MENU_OP.START,
        MENU_OP.EDIT,
        MENU_OP.VESSEL_APPROVE,
        MENU_OP.DECLINE,
        MENU_OP.VESSEL_CANCEL,
        MENU_OP.DELETE,
    ],
    [OPERATION_TYPE.SERVICE]: [
        MENU_OP.DETAIL,
        MENU_OP.START,
        MENU_OP.EDIT,
        MENU_OP.VESSEL_APPROVE,
        MENU_OP.DECLINE,
        MENU_OP.VESSEL_CANCEL,
    ],
    [OPERATION_TYPE.SUPPORT]: [
        MENU_OP.DETAIL,
        MENU_OP.START,
        MENU_OP.VESSEL_APPROVE,
        MENU_OP.DECLINE,
        MENU_OP.VESSEL_CANCEL,
    ],
}


